<div class="modal-body">
  <div class="container-fluid" style="width: 100%;height: 100%;">
    <div id="header" class="row justify-content-between">
      <label>{{ header }}</label>
      <div class="close-button" (click)="modalRef.hide()"></div>
    </div>
    <table id="table" *ngIf="hasEvents">
      <thead>
        <th>
          PASS NAME
        </th>
        <th>
          PRICE
        </th>
        <th>MAX AVAIL</th>
        <th>SOLD</th>
        <th></th>
        <th></th>
      </thead>
      <tbody>
        <tr *ngFor="let uiEvent of events">
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td>
            <a style="color: #429DFF" (click)="details(uiEvent.product)"
              ><img
                src="../../../assets/icons/edit.svg"
                style="width:15px;height:15px;margin-right: 5px;"
              /><u style="font-size: 15px;">Details</u></a
            >
          </td>
          <td>
            <a style="color: #429DFF" (click)="schedule(uiEvent.product)"
              ><img
                src="../../../assets/icons/edit.svg"
                style="width:15px;height:15px;margin-right: 5px;"
              /><u style="font-size: 15px;">Schedule</u></a
            >
          </td>
        </tr>
      </tbody>
    </table>
    <div id="no-events" *ngIf="!hasEvents">
      There are no passes on this date.
    </div>
    <div id="footer" class="row justify-content-center">
      <div class="submit-button" (click)="addPass()">
        Add New Pass
      </div>
    </div>
  </div>
</div>
